<template>
  <v-container class="ma-0 pa-0 mw-100">
    <settings-dialog v-if="settingsDialog" @close="settingsDialog = false" />
    <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
      <v-row>
        <v-col cols="12">
          <v-alert border="top" colored-border color="#1e6668" text type="info">
            {{ $t('RevokePage.info_text') }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <header-medium :text="$t('RevokePage.found_signers')"></header-medium>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12">
          <v-data-table :headers="headers" :items="certificates" item-key="certificate_id" sort-by="serial_number"
            sortDesc :items-per-page="10" class="elevation-1" :footer-props="{
              disableItemsPerPage: true,
              itemsPerPageOptions: [],
              itemsPerPageText: '',
            }">
            <template v-slot:item.status="{ item }">
              {{
                item.status == "v" ? $t("RevokePage.valid") : (item.status == "r") ? $t("RevokePage.revoked") :
                $t("RevokePage.expired")
              }}
            </template>
            <template v-slot:item.type="{ item }">
              {{
                item.type == "aes" ? $t("RevokePage.aes") : $t("RevokePage.qes")
              }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-container class="ma-0 pa-0 mw-100" v-if="item.status === 'v'">
                <v-tooltip top key="revoke">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="custom-icon2" @click="revoke(item)" v-bind="attrs" v-on="on">
                      mdi-delete
                    </v-icon>
                  </template>
                  <span>{{ $t("Tooltips.revoke") }}</span>
                </v-tooltip>
              </v-container>
            </template>
            <template v-slot:no-data>
              {{ $t("Headers.no_data") }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-container class="ma-0 pa-0 mw-100" v-if="settingsChangable">
        <v-row justify="center">
          <v-col cols="12" sm="12">
            <header-medium :text="$t('RevokePage.settings')"></header-medium>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="12" class="text-center"> {{ $t('RevokePage.phone_text') }} </v-col>
        </v-row>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="6">
              <vue-tel-input-vuetify filled v-model="new_phone" defaultCountry="DE" :label="$t('Headers.phone')"
                mode="international" />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field filled v-model="confirm_password" :label="$t('Headers.password')"
                :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (showOldPassword = !showOldPassword)" :type="showOldPassword ? 'text' : 'password'"
                :rules="[(v) => !!v || $t('LoginRegisterPage.labels.required')]" required></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" class="text-right">
              <custom-button :text="$t('Headers.save')" @click="changePhone"></custom-button>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import i18n from "../../i18n";
import HeaderSmall from "../../components/ui/text/HeaderSmall";
import CustomButton from "../../components/ui/input/CustomButton";
import cookie from 'vue-cookies';

import { log } from "@/helpers/logger";

export default {
  name: "revoke-table",
  components: {
    HeaderMedium,
    HeaderSmall,
    CustomButton,
  },
  props: {
    certificates: Array,
    email: String,
    phone: String
  },
  data() {
    return {
      settingsDialog: false,
      mainColor: this.$vuetify.theme.themes.light.primary,
      select: '',
      showOldPassword: false,
      headers: [
        {
          value: "serial_number",
          text: i18n.t("RevokePage.serial_number"),
          sortable: true,
        },
        {
          value: "status",
          text: i18n.t("RevokePage.status"),
          sortable: true,
        },
        {
          value: "not_before",
          text: i18n.t("RevokePage.not_before"),
          sortable: true,
        },
        {
          value: "not_after",
          text: i18n.t("RevokePage.not_after"),
          sortable: true,
        },
        {
          value: "type",
          text: i18n.t("RevokePage.type"),
          sortable: true,
        },
        {
          value: "actions",
          text: "",
        },
      ],
      summaryText: "",
      confirm_password: "",
      new_phone: '',
      settingsChangable: false,
      isMobile: false
    };
  },
  created() {
    if (this.phone) {
      this.settingsChangable = true;
      this.new_phone = this.phone;
    }

    this.isMobile = this.detectMobile()
  },
  methods: {
    detectMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    async startNect() {
      cookie.set('passwordReset', true, 60 * 30)
      await this.$store
        .dispatch("data/getSignerByEmail", {
          email: this.email
        })
        .then((resp) => {
          this.$store.dispatch("data/startNectRevoke", resp).then((res) => {
            window.location.href = res.nect_url;
          });
        })
        .catch((err) => {
          phone = "";
          log("RevokePage.RevokeTable.revoke() - " + err, "error");
        });
    },
    async changePhone() {
      if (this.$refs.form.validate()) {
        var new_phone_number = this.new_phone;
        await this.$store.dispatch("data/changePhone", {
          email: this.email,
          phone: this.new_phone,
          password: this.confirm_password
        })
          .then(() => {
            this.$refs.form.reset();
          })
          .catch((err) => {
            log("RevokePage.RevokeTable.changePhone() - " + err, "error");
          })
          .finally(() => {
            this.new_phone = new_phone_number;
          });
      }
    },
    async revoke(data) {
      var phone = "";

      await this.$store
        .dispatch("data/getSignerByEmail", {
          email: this.email,
          reason: this.reason
        })
        .then((resp) => {
          phone = resp.phone;
          log(
            "RevokePage.RevokeTable.revoke() - get OTP for signer " +
            this.signer_id,
            "info"
          );
          this.$store
            .dispatch("data/revokeSMS", {
              signer_id: data.signer_id,
              phone: phone,
            })
            .then((resp) => {
              log(
                "RevokePage.RevokeTable.revoke() - get OTP for signer " +
                this.signer_id,
                "info"
              );
              this.$emit('type', data.type)
              this.$emit("ips_id", resp);
              this.$emit("sent", data);
            })
            .catch((err) => {
              log("RevokePage.RevokeTable.revoke() - " + err, "error");
            });
        })
        .catch((err) => {
          phone = "";
          log("RevokePage.RevokeTable.revoke() - " + err, "error");
        });
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .logo_size {
    width: 140px;
    height: 140px;
  }

  .logo_width {
    width: 250px;
  }
}

@media only screen and (min-width: 600px) {
  .logo_size {
    width: 140px;
    height: 140px;
  }

  .logo_width {
    width: 200px;
  }
}
</style>